webpackJsonp([273630050305216],{

/***/ 1832:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin: 200px 0 100px;\n  min-height: 45vh;\n\n  @media screen and (max-width: 768px) {\n    width: 90%;\n    margin: 50px auto;\n  }\n'], ['\n  margin: 200px 0 100px;\n  min-height: 45vh;\n\n  @media screen and (max-width: 768px) {\n    width: 90%;\n    margin: 50px auto;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  max-width: 800px;\n  margin: auto;\n\n  & * {\n    p,\n    h1,\n    h2 {\n      margin-bottom: 30px;\n    }\n  }\n'], ['\n  max-width: 800px;\n  margin: auto;\n\n  & * {\n    p,\n    h1,\n    h2 {\n      margin-bottom: 30px;\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(16);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _SiteConfig = __webpack_require__(13);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarkdownPage = function (_React$Component) {
	  _inherits(MarkdownPage, _React$Component);
	
	  function MarkdownPage() {
	    _classCallCheck(this, MarkdownPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  MarkdownPage.prototype.render = function render() {
	    var slug = this.props.pathContext.slug;
	
	    var pageNode = this.props.data.markdownRemark;
	    var meta = pageNode.frontmatter;
	
	    return _react2.default.createElement(
	      PageContainer,
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          meta.title + ' | ' + _SiteConfig2.default.siteTitle
	        )
	      ),
	      _react2.default.createElement(
	        PageBody,
	        null,
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: pageNode.html } })
	      )
	    );
	  };
	
	  return MarkdownPage;
	}(_react2.default.Component);
	
	exports.default = MarkdownPage;
	
	
	var PageContainer = _styledComponents2.default.div(_templateObject);
	
	var PageBody = _styledComponents2.default.div(_templateObject2);
	
	/* eslint no-undef: "off"*/
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-markdown-page-jsx-8bb7b56fbf1889067786.js